/*
* Pipeline Theme
*
* Custom Javascript
*/

document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.querySelector('.collection__filters__wrapper');
  if (!drawer) return;

  var originalParent = drawer.parentNode;
  var originalNextSibling = drawer.nextSibling;

  function moveDrawerForMobile() {
    if (window.innerWidth <= 767) {
      if (drawer.parentNode !== document.body) {
        document.body.appendChild(drawer);
      }
    } else {
      if (drawer.parentNode === document.body) {
        if (originalNextSibling && originalNextSibling.parentNode === originalParent) {
          originalParent.insertBefore(drawer, originalNextSibling);
        } else {
          originalParent.appendChild(drawer);
        }
      }
    }
  }

  moveDrawerForMobile();
  window.addEventListener('resize', moveDrawerForMobile);
});

console.log("WHL title sync script loaded");

$(document)
  .off("click.whlTitleSync")
  .on("click.whlTitleSync", ".siblings__link", function () {
    var $swatch = $(this);
    var newProductTitle = $swatch.data("swatch-product-title");
    var $title = $swatch.closest(".product-grid-item").find(".product__grid__title").first();

    console.log("WHL swatch clicked");
    console.log("New title:", newProductTitle);
    console.log("Title found:", $title.length);

    if (newProductTitle && $title.length) {
      $title.text(newProductTitle);
      console.log("Title updated to:", $title.text());
    }
  });


function initWhlSizeGuideInnerTabs() {
  if (document.body.dataset.whlSizeGuideTabsBound === 'true') return;
  document.body.dataset.whlSizeGuideTabsBound = 'true';

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-size-guide-tab-trigger]');
    if (!trigger) return;

    event.preventDefault();

    const holder = trigger.closest('[data-size-guide-tabs]');
    if (!holder) return;

    const target = trigger.getAttribute('data-size-guide-tab-trigger');
    const triggers = holder.querySelectorAll('[data-size-guide-tab-trigger]');
    const panels = holder.querySelectorAll('[data-size-guide-tab-panel]');

    triggers.forEach((btn) => btn.classList.remove('is-active'));
    panels.forEach((panel) => panel.classList.remove('is-active'));

    trigger.classList.add('is-active');

    const activePanel = holder.querySelector('[data-size-guide-tab-panel="' + target + '"]');
    if (activePanel) {
      activePanel.classList.add('is-active');
    }
  });
}

window.addEventListener('DOMContentLoaded', () => {
  initWhlSizeGuideInnerTabs();
});

document.addEventListener('shopify:section:load', () => {
  initWhlSizeGuideInnerTabs();
});

function initWhlSizeGuideInnerTabs() {
  if (document.body.dataset.whlSizeGuideTabsBound === 'true') return;
  document.body.dataset.whlSizeGuideTabsBound = 'true';

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-size-guide-tab-trigger]');
    if (!trigger) return;

    event.preventDefault();

    const holder = trigger.closest('[data-size-guide-tabs]');
    if (!holder) return;

    const target = trigger.getAttribute('data-size-guide-tab-trigger');
    const triggers = holder.querySelectorAll('[data-size-guide-tab-trigger]');
    const panels = holder.querySelectorAll('[data-size-guide-tab-panel]');

    triggers.forEach((btn) => btn.classList.remove('is-active'));
    panels.forEach((panel) => panel.classList.remove('is-active'));

    trigger.classList.add('is-active');

    const activePanel = holder.querySelector('[data-size-guide-tab-panel="' + target + '"]');
    if (activePanel) {
      activePanel.classList.add('is-active');
    }
  });
}


$(document).on('click', '[data-sidebar-filter-form] input, [data-sidebar-filter-form] label, [data-filter-update-url]', function () {
  var $grid = $('[data-products-grid]').first();
  if ($grid.length) {
    $grid.addClass('is-loading');
  }
});

document.addEventListener('click', function (event) {
  var openButton = event.target.closest('[data-popup-modal-open]');
  var closeButton = event.target.closest('[data-popup-modal-close]');

  if (openButton) {
    event.preventDefault();

    var modalId = openButton.getAttribute('aria-controls');
    var modal = document.getElementById(modalId);

    if (!modal) return;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    openButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('popup-modal-open');
  }

  if (closeButton) {
    var modal = closeButton.closest('[data-popup-modal]');
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('popup-modal-open');

    var opener = document.querySelector('[aria-controls="' + modal.id + '"]');
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
    }
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;

  var openModal = document.querySelector('.popup-modal.is-open');
  if (!openModal) return;

  openModal.classList.remove('is-open');
  openModal.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('popup-modal-open');

  var opener = document.querySelector('[aria-controls="' + openModal.id + '"]');
  if (opener) {
    opener.setAttribute('aria-expanded', 'false');
  }
});